if (!customElements.get('approval-delivery-date')) {
    class ApprovalDeliveryDate extends HTMLElement {

        constructor() {
            super();

            this.key = this.dataset.key;

            this.checkoutErrorModal = document.getElementById('checkout-response-error');
            this.optionSelect = this.querySelector('.line-item-delivery-action');

            try {
                this.deliveryItem = JSON.parse(this.querySelector(`[data-delivery-item="${this.key}"]`)?.innerText);
            } catch (e) {
                if (this.checkoutErrorModal) {
                    this.checkoutErrorModal.html = `File: <b>component-approval-delivery-date.js</b><br />SyntaxError: <b>JSON.parse</b><br />Provider: <b>document.querySelector(\`[data-delivery-item="${this.key}"]\`).innerText</b><br /><hr style="margin: 10px 0 5px;" />`;
                    this.checkoutErrorModal.message = `${e}`;
                    this.checkoutErrorModal.stack = e.stack;
                    this.checkoutErrorModal.open(this);
                }
            }

            try {
                this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);
            } catch (e) {
                if (this.checkoutErrorModal) {
                    this.checkoutErrorModal.html = `File: <b>component-approval-delivery-date.js</b><br />SyntaxError: <b>JSON.parse</b><br />Provider: <b>document.querySelector(\`[data-item="${this.key}"]\`).innerText</b><br /><hr style="margin: 10px 0 5px;" />`;
                    this.checkoutErrorModal.message = `${e}`;
                    this.checkoutErrorModal.stack = e.stack;
                    this.checkoutErrorModal.open(this);
                }
            }
        }

        connectedCallback() {
            this.optionSelect.addEventListener('change', this.handleRadioChanged.bind(this));
        }

        disconnectedCallback() {
            this.optionSelect.removeEventListener('change', this.handleRadioChanged.bind(this));
        }

        async handleRadioChanged(e) {

            window.checkout.loading = true;

            switch (e.target.value) {
                case 'NEXT_DELIVERY_DATE': await this.handleFull(e); break;
                case 'PARTIAL_DELIVERY': await this.handlePartial(e); break;
                case 'CANCELLATION': await this.handleCancel(e); break;
                default: break;
            }

            await window.checkout.handleUpdate();
        }

        async handleCancel(e) {

            if (this.deliveryItem == null) {
                return;
            }

            const id = this.deliveryItem.id || this.item.id;
            LocalCart.updateQuantity(id, 0);            

            this.deliveryItem = null;

            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

            return;
        }

        async handleFull(e) {

            const qty = this.item.properties['_original_qty'] ? parseInt(this.item.properties['_original_qty']) : this.item.quantity;

            const payload = {
                id: this.deliveryItem ? this.deliveryItem.key : this.item.id,
                quantity: qty,
                properties: {
                    ...this.item.properties,
                    ...(this.item.properties['_possible_next_delivery_date'] ? { '_next_delivery_date': this.item.properties['_possible_next_delivery_date'] } : {}),
                    // 'Lieferterminabweichung': 'Die lieferung erfolgt mit einer späteren Anlieferung.',
                    '_resolved': true,
                    '_canceled': false,
                }
            };

            LocalCart.updateProps(this.item.id, payload.properties);
            LocalCart.updateQuantity(this.item.id, payload.quantity);

            this.deliveryItem = LocalCart.getCartItem(this.item.id);
            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);
        }

        async handlePartial(e) {

            const qty = this.item.properties['_original_qty'] ? parseInt(this.item.properties['_original_qty']) : this.item.quantity;

            const payload = {
                id: this.deliveryItem ? this.deliveryItem.key : this.item.id,
                quantity: qty - parseInt(this.item.properties['_available']),
                properties: {
                    ...this.item.properties,
                    ...(this.item.properties['_possible_next_delivery_date'] ? { '_next_delivery_date': this.item.properties['_possible_next_delivery_date'] } : {}),
                    // 'Lieferterminabweichung': 'Die lieferung erfolgt mit einer späteren Anlieferung.',
                    '_resolved': true,
                    '_canceled': false,
                }
            }

            LocalCart.updateProps(this.item.id, payload.properties);
            LocalCart.updateQuantity(this.item.id, payload.quantity);

            this.deliveryItem = LocalCart.getCartItem(this.item.id);
            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

        }

        async handleSubmit(payload) {

            try {

                if (this.deliveryItem == null) {

                    const addRequest = await fetch(`${window.theme.routes.cartAdd}.js`, {
                        method: 'POST',
                        headers: window.getCartHeaders(),
                        body: JSON.stringify({
                            items: [payload]
                        })
                    });

                    if (addRequest.ok) {

                        const { items } = await addRequest.json();
                        this.deliveryItem = items[0];

                        this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

                    } else {

                        throw new Error(`Alternative delivery for product ${this.item.id} failed!`);
                    }

                } else {

                    this.deliveryItem.quantity = payload.quantity;
                    this.deliveryItem.properties = payload.properties;

                    this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

                    return fetch(`${window.theme.routes.cartChange}.js`, {
                        method: 'POST',
                        headers: window.getCartHeaders(),
                        body: JSON.stringify(payload)
                    });
                }

            } catch (e) {
                if (this.checkoutErrorModal) {
                    this.checkoutErrorModal.html = `File: <b>component-approval-delivery-date.js</b><br /><hr style="margin: 10px 0 5px;" />`;
                    this.checkoutErrorModal.message = `${e}`;
                    this.checkoutErrorModal.stack = e.stack;
                    this.checkoutErrorModal.open(this);
                }
            }

            return;
        }
    }

    customElements.define('approval-delivery-date', ApprovalDeliveryDate);
}